import './depot-agents-view/depot-agents-view.component';
import './depot-agents-view/depot-agents-view.scss';

import './depot-branches-view/depot-branches-view.component';
import './depot-branches-view/depot-branches-view.scss';

/*
import './depot-details/depot-details.component';
import './depot-details/depot-details.scss';
*/

import './depot-contact-people-view/depot-contact-people-view.component';
import './depot-contact-people-view/depot-contact-people-view.scss';

import './depot-details/depot-details.component';
import './depot-details/depot-details.scss';

import './depot-display-value/depot-display-value.component';
import './depot-display-value/depot-display-value.scss';

import './depot-link/depot-link.component';

import './depot-table/depot-table.component';
import './depot-table/depot-table.scss';

import './depot-table-row/depot-table-row.component';
import './depot-table-row/depot-table-row.scss';

import './depot-schedule-view/depot-schedule-view.component';
import './depot-schedule-view/depot-schedule-view.scss';

import './depot-select/depot-select.component';
import './depot-select/depot-select.scss';

import './depot-shipper-accounts-view/depot-shipper-accounts-view.component';
import './depot-shipper-accounts-view/depot-shipper-accounts-view.scss';

import './depots-display-list/depots-display-list.component';
import './depots-display-list/depots-display-list.scss';

import './depots-multi-select/depots-multi-select.component';
import './depots-multi-select/depots-multi-select.scss';

import './depots-multi-select-list/depots-multi-select-list.component';
import './depots-multi-select-list/depots-multi-select-list.scss';

import './depot-select-list/depot-select-list.component';
import './depot-select-list/depot-select-list.scss';

import './depots-table/depots-table.component';
import './depots-table/depots-table.scss';

import './depots-table-row/depots-table-row.component';
import './depots-table-row/depots-table-row.scss';

import './depots-view/depots-view.component';
import './depots-view/depots-view.scss';

import './depot-inventory-config-view/depot-inventory-config-view.component';
import './depot-inventory-config-view/depot-inventory-config-view.scss';

import './depot-inventory-transactions-view/depot-inventory-transactions-view.component';
import './depot-inventory-transactions-view/depot-inventory-transactions-view.scss';
